<template>
    <el-button :type="type"
        @click="__submit"
        :loading="processing"
        :disabled="disabled"
        :plain="plain"
        :round="round"
        :circle="circle"
        :icon="icon"
        :autofocus="autofocus"><slot/></el-button>
</template>

<script>
import uuidv1 from 'uuid/v1'
export default {
    name: 'v-submit-btn',
    props: {
        model: {
            type: [Object, Function]
        },
        beforeSubmit: {
            type: Function,
            default () {
                return () => {
                    return new Promise(resolve => {
                        resolve(true)
                    })
                }
            }
        },
        api: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'primary'
        },
        tokenKey: {
            type: String,
            default: 'tid'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // TODO 其余属性支持
        plain: {
            type: Boolean,
            default: false
        },
        circle: {
            type: Boolean,
            default: false
        },
        round: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: ''
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            token: uuidv1(),
            processing: false,
            lock: false,
            limit: 1000,
            timeout: 3,
            timer: null
        }
    },
    methods: {
        submit () {
            this.__submit()
        },
        async __submit () {
            if (this.lock) {
                this.$tips(`处理中...`, 'error')
                return
            }
            let ret = await this.beforeSubmit()
            if (!ret) return
            this.processing = true
            let model = typeof this.model === 'function' ? this.model() : this.model
            return this.$api(this.api, model, {
                [this.tokenKey]: this.token
            }).then(res => {
                this.$emit('success', res)
                this.token = uuidv1()
                this.processing = false
            }).catch(err => {
                if (err.code === 409) {
                    this.onRepeat()
                }
                else {
                    this.$tips(err.msg, 'error')
                    this.$emit('error', err)
                }
                if (process.env.NODE_ENV === 'development') console.error(err)
                this.processing = false
            })
        },
        onRepeat () {
            this.lock = true
            this.timer = setTimeout(() => {
                this.timeout--
                if (!this.timeout) {
                    clearTimeout(this.timer)
                    this.lock = false
                    this.token = uuidv1()
                    this.$nextTick(() => {
                        this.timeout = 3
                    })
                } else {
                    this.onRepeat()
                }
            }, this.limit)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/framework/widgets/submit-btn.vue